import { render, staticRenderFns } from "./ready-to-ship-status-form.component.vue?vue&type=template&id=75448dd9&"
import script from "./ready-to-ship-status-form.component.vue?vue&type=script&lang=ts&"
export * from "./ready-to-ship-status-form.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports